import request from "./request";
/**
 * 批量留言
 * @param ids 用户名
 * @param note 当前页数
 */
export default async function batchMessage(data) {
  return await request.post("/spin/dataSend/batchMessage", data);
}
